import React from 'react'
import ProductsSectionTitle from '../ProductsSectionTitle';
import { Element } from 'react-scroll';
import { Link } from 'react-router-dom';

const FlexibleIntegration = () => {
  return (
    <>
      <Element
        name="FlexibleIntegration"
        className="datatalent-section-gap bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <ProductsSectionTitle
                classes = "text-center"
                title = "Flexible Integration & Customization"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <div className="aaai-content">
                <p>AURA Agentic AI integrates with MEA Edge AI and 3rd-party hardware, can be tailored for your exact workflows and regulations, and supports both YAML/JSON config for rapid deployment.</p>
              </div>
            </div>
            <div className="col-12 mt--80 px-0 px-md-4">
              <div className="row g-5 position-relative ba-footer">
                <div className="col-lg-7 p-0 mt-0">
                  <h3 className="color-white">Ready to Deploy Agentic AI?</h3>
                  <p className="color-white">Contact us for tailored demos, or explore more in our Industry solutions.</p>
                  <Link to="/contact-us">Contact Sales <img src={`${process.env.PUBLIC_URL}/images/business-accelerator/icons/maki_arrow.svg`} alt="right arrow" /></Link>
                </div>
                <div className="col-lg-2 d-none d-md-block"></div>
                <div className="col-lg-3 p-0 justify-content-center align-items-center d-flex">
                  <Link className="edu-btn datatalent-cta" to="/contact-us">Contact Sales</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default FlexibleIntegration;